/* One source for sticky offsets. Scroll never measures layout. */
(() => {
  const header=document.getElementById('shopify-section-header');
  const inner=header?.querySelector('.header-ios-fix');
  if (!inner || !header.querySelector('.header-dac')) return;
  const root=document.documentElement;
  const mobile=matchMedia('(max-width:1279px)');
  let compact=false, expanded=inner.getBoundingClientRect().height, current=expanded, frame=0, lastOffset=-1;
  function measure() {
    frame=0;
    current=inner.getBoundingClientRect().height;
    if (!compact) expanded=current;
    const gap=mobile.matches && compact ? Math.max(0,expanded-current) : 0;
    header.style.setProperty('--dac-header-reserve',mobile.matches ? expanded+'px' : '0px');
    header.style.setProperty('--dac-header-shift',gap+'px');
    if (lastOffset!==current) { root.style.setProperty('--dac-header-height',current+'px');lastOffset=current; }
  }
  function schedule() { if(!frame)frame=requestAnimationFrame(measure); }
  function scrollState() {
    const next=compact ? scrollY>24 : scrollY>Math.max(160,expanded+16);
    if(next===compact)return;
    compact=next;
    window.dispatchEvent(new CustomEvent('dac:header-state',{detail:compact}));
    schedule();
  }
  new ResizeObserver(schedule).observe(inner);
  addEventListener('scroll',scrollState,{passive:true});
  addEventListener('pageshow',()=>{scrollState();schedule();});
  addEventListener('resize',schedule,{passive:true});
  mobile.addEventListener('change',()=>{
    compact=false;
    window.dispatchEvent(new CustomEvent('dac:header-state',{detail:false}));
    requestAnimationFrame(()=>{measure();scrollState();});
  });
  measure(); scrollState();
})();
